<template>
  <div class="integral-details">
    <div class="header">
      <div class="currentScore">当前课时</div>
      <div>{{ sum }}</div>
      <div class="line"></div>
      <div class="nav acea-row">
        <div class="item">
          <div class="num">{{ sums }}</div>
          <div>累计总课时</div>
        </div>
        <div class="item">
          <div class="num">{{ sums - sum }}</div>
          <div>已上课时</div>
        </div>
        <div class="item">
          <div class="num">{{ sums }}</div>
          <div>已购课时</div>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="nav acea-row">
        <div class="item acea-row row-center-wrapper" :class="current === index ? 'on' : ''"
          v-for="(item, index) in navList" :key="index" @click="nav(index)">
          <span class="iconfont" :class="item.icon"></span>{{ item.name }}
        </div>
      </div>
      <div class="list" :hidden="current !== 0">
        <div class="tip acea-row row-middle">
          <span class="iconfont icon-shuoming"></span>提示：不缺课 不旷课 连续签到可获得丰厚礼物
        </div>
        <div class="item acea-row row-between-wrapper" v-for="(item, index) in list" :key="index"
          v-if="item.uid == paramsuid || item.uid == paramsuids">
          <div>
            <div class="state">{{ item.mark }}</div>
            <div>{{ item.add_time }}</div>
          </div>
          <div class="num" v-if="item.pm == 1">+{{ item.number }}</div>
          <div class="num font-color-red" v-if="item.pm == 0">
            -{{ item.number }}
          </div>
        </div>
      </div>
      <div class="list2" :hidden="current !== 1">
        <router-link class="item acea-row row-between-wrapper" :to="'/user/poster'">
          <div class="pictrue"><img src="@assets/images/score.png" /></div>
          <div class="name">邀请其他宝宝一起来上课可以获得课时哦</div>
          <div class="earn">赚课时</div>
        </router-link>
        <!-- <router-link class="item acea-row row-between-wrapper" :to="'/user/sign'">
          <div class="pictrue"><img src="@assets/images/score.png" /></div>
          <div class="name">每日签到可获得课时奖励</div>
          <div class="earn">赚课时</div>
        </router-link> -->
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getIntegralList, postSignUser, getUserStudent } from "../../../api/user";
import Loading from "@components/Loading";
export default {
  name: "Integral",
  components: {
    Loading
  },
  props: {},
  data: function () {
    return {
      navList: [
        { name: "课时明细", icon: "icon-mingxi" },
        { name: "课时提升", icon: "icon-tishengfenzhi" }
      ],
      current: 0,
      paramsuid: 0,
      paramsuids: 0,
      where: {
        page: 1,
        limit: 15
      },
      data: {
        sign: 1,
        integral: 1,
        all: 1
      },
      list: [],
      info: [],
      loaded: false,
      loading: false,
      sums: 0,
      sum: 0,
    };
  },
  mounted: function () {
    this.getIntegral();
    this.getInfo();
    this.getUserStudentLsson();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getInfo();
    });
  },
  methods: {
    nav: function (index) {
      this.current = index;
    },

    getInfo: function () {
      let that = this;
      if (that.loaded == true || that.loading == true) return;
      that.loading = true;
      getIntegralList(that.where).then(
        res => {
          that.loading = false;
          that.loaded = res.data.length < that.where.limit;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.list.push.apply(that.list, res.data);
          let jifen = that.list
          let index = jifen.findIndex(person => person.uid == this.$route.params.uid);
          jifen.splice(index, 1);

        }
      );
    },
    getUserStudentLsson() {
      getUserStudent(this.$route.params.uid).then(res => {
        this.userSutdentInfoList = res.data;
        this.paramsuid = this.userSutdentInfoList.student[0].Id
        this.paramsuids = this.userSutdentInfoList.student[1].Id
        const hourList = res.data.studentProduct;
        console.log(hourList);
        if (!this.sums && !this.sum) {
          for (let item of hourList) {
            for (let item_mix of item) {
              if (item_mix.classtime && item_mix.classtimes)
                this.sum += item_mix.classtime;
              this.sums += item_mix.classtimes;
            }
          }
        }
      })
    },
    getIntegral: function () {
      let that = this;
      postSignUser(that.data).then(
        res => {
          that.info = res.data;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    }
  }
};
</script>
